import {
  createVisualEditorStore,
  VisualEditorStore,
} from '@/domain/dienstplan/features/VisualEditor/store';
import { VisualEditor } from '@/domain/dienstplan/features/VisualEditor/VisualEditor';
import { VisualEditorContextProvider } from '@/domain/dienstplan/features/VisualEditor/VisualEditorContext';
import { useStandort } from '@/domain/dienstplan/shared/hooks/useStandort/useStandort';
import { Arbeitsbereich } from '@/domain/dienstplan/shared/types/Arbeitsbereich';
import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { getOffsetFromTageswechsel } from '@/domain/dienstplan/shared/utils/getOffsetFromTageswechsel';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useParentSize } from '@visx/responsive';
import { createContext, useRef } from 'react';

// oxlint-disable-next-line react/only-export-components
export const StoreContext = createContext<VisualEditorStore | null>(null);

export function VisualEditorWrapper({
  selectedArbeitsbereich,
  wochentag,
  belegungen,
}: {
  selectedArbeitsbereich: Arbeitsbereich;
  wochentag: Weekday;
  belegungen: BelegungsIntervall[];
}) {
  const { parentRef, width, height } = useParentSize();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { tageswechsel } = useStandort(standortId);
  const offset = getOffsetFromTageswechsel(tageswechsel);
  const store = useRef(createVisualEditorStore(belegungen, offset)).current;

  return (
    <div className="flex flex-col gap-2 w-full bg-white rounded-md items-center justify-center">
      <div ref={parentRef} className="w-full h-[600px]">
        <StoreContext value={store}>
          <VisualEditorContextProvider
            width={width}
            height={height}
            selectedArbeitsbereich={selectedArbeitsbereich}
            maxMitarbeiterAnzahl={
              selectedArbeitsbereich?.mindestbelegungen.find(
                (mb) => mb.tag === wochentag,
              )?.einstellungen?.maxAnzahlMitarbeiter ?? 12
            }>
            <VisualEditor
              key={belegungen.reduce((acc, curr) => acc + curr.belegung.id, '')}
            />
          </VisualEditorContextProvider>
        </StoreContext>
      </div>
    </div>
  );
}
